import {AfterViewInit, Component, HostListener, ViewChild} from '@angular/core';
import {Platform} from "@angular/cdk/platform";
import {SignatureService} from "../../services/signature.service";

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements AfterViewInit {
    @ViewChild('sigPad') sigPad;
    sigPadElement;
    context;
    isDrawing = false;
    img;

    constructor(private platform: Platform, private signatureService: SignatureService) {
    }

    ngAfterViewInit() {
        this.sigPadElement = this.sigPad.nativeElement;
        if (this.isDesktop()) {
            this.sigPadElement.height = 300;
            this.sigPadElement.width =650;
        } else {
            this.sigPadElement.height = window.innerHeight * 0.75;
            this.sigPadElement.width = window.innerWidth * 0.8;
        }
        this.context = this.sigPadElement.getContext('2d');
        this.context.strokeStyle = 'black';

        // Aggiunta degli eventi touch
        this.sigPadElement.addEventListener('touchstart', this.onTouchStart.bind(this));
        this.sigPadElement.addEventListener('touchmove', this.onTouchMove.bind(this));
        this.sigPadElement.addEventListener('touchend', this.onTouchEnd.bind(this));
    }

    @HostListener('document:mouseup', ['$event'])
    onMouseUp(e) {
        this.isDrawing = false;
    }

    onMouseDown(e) {
        this.isDrawing = true;
        const coords = this.relativeCoords(e);
        this.context.moveTo(coords.x, coords.y);
    }

    onMouseMove(e) {
        if (this.isDrawing) {
            const coords = this.relativeCoords(e);
            this.context.lineTo(coords.x, coords.y);
            this.context.stroke();
        }
    }

    onTouchStart(e: TouchEvent) {
        e.preventDefault();
        this.isDrawing = true;
        const coords = this.relativeCoords(e.touches[0]);
        this.context.moveTo(coords.x, coords.y);
    }

    onTouchMove(e: TouchEvent) {
        e.preventDefault();
        if (this.isDrawing) {
            const coords = this.relativeCoords(e.touches[0]);
            this.context.lineTo(coords.x, coords.y);
            this.context.stroke();
        }
    }

    onTouchEnd(e: TouchEvent) {
        e.preventDefault();
        this.isDrawing = false;
    }

    private relativeCoords(event) {
        const bounds = this.sigPadElement.getBoundingClientRect();
        const x = event.clientX - bounds.left;
        const y = event.clientY - bounds.top;
        return {x: x, y: y};
    }

    clear() {
        this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
        this.context.beginPath();
    }

    save() {
        if (this.isDesktop()) {
            // Per desktop, salva l'immagine normalmente
            this.img = this.sigPadElement.toDataURL("image/png");
        } else {
            // Per dispositivi mobili, ruota l'immagine di 90 gradi in senso antiorario
            const tempCanvas = document.createElement('canvas');
            const tempContext = tempCanvas.getContext('2d');

            // Imposta le dimensioni invertite per la rotazione
            tempCanvas.width = this.sigPadElement.height;
            tempCanvas.height = this.sigPadElement.width;

            // Ruota il canvas in senso antiorario
            tempContext.translate(tempCanvas.width / 2, tempCanvas.height / 2);
            tempContext.rotate(-90 * Math.PI / 180); // Rotazione di 90 gradi antiorario
            tempContext.drawImage(
                this.sigPadElement,
                -this.sigPadElement.width / 2,
                -this.sigPadElement.height / 2
            );

            // Salva l'immagine dal canvas temporaneo
            this.img = tempCanvas.toDataURL("image/png");
        }

        this.signatureService.saveData(this.img);
        this.signatureService.resetData();
    }

    close() {
        this.signatureService.close();
    }

    isDesktop() {
        return (!this.platform.IOS && !this.platform.ANDROID);
    }


}
